export default {
  'ni-protocol': {
    'established-or-registered-in-ni-label':
      'Is your business established or registered in Northern Ireland?',
    'part-of-group-operating-in-ni-label':
      'Does your business have any active subsidiaries, an active parent company, a business in the same corporate group and / or operations in Northern Ireland? Or does your business have plans to operate any such entities, or establish other operations in Northern Ireland within the next three years?',
    'provides-specific-service-to-ni-label':
      'Does your business provide a service or is it part of a supply chain which is specifically tailored to the needs of a customer or customers in Northern Ireland that manufacture or sell goods or participate in the Northern Ireland wholesale electricity market?',
    'operates-in-electricity-market-in-ni-label':
      'Is your business involved in the manufacture or sale of goods or does it operate in the Northern Ireland Wholesale Electricity Market (or have plans to start manufacturing or selling such goods or to operate in the Northern Ireland Wholesale Electricity Market in the next three years)?'
  },
  'number-of-employees': {
    subtitle:
      'We’ve helped over 100,000 businesses fund their next step, so you’re in good hands.',
    paragraph: 'Next we need a few details about your business.',
    label:
      'Pick the number of people your business employs full-time, excluding directors.'
  },
  'self-stated-industry': {
    label: 'Select industry'
  },
  selfStatedTurnover: {
    subtitle: 'What was your turnover in your last financial year?',
    label: 'Amount'
  },
  selfStatedTurnoverFor2019: {
    subtitle: 'What was your turnover in the 2019 financial year?',
    clarification: "If your business was formed after 2019, please enter '0'.",
    label: 'Amount'
  },
  profitability: {
    subtitle: 'How much profit or loss do you make?',
    label: 'In the last financial year, did you make a profit or loss?',
    value: 'And by how much?'
  },
  overdraft: {
    subtitle: 'Does your business bank account have an overdraft?',
    'has-overdraft': 'Do you have an overdraft facility?',
    'overdraft-limit': 'What’s your overdraft limit?',
    'overdraft-usage': 'How much of your overdraft are you currently using?',
    label: 'Amount'
  },
  'other-debt': {
    title: 'Have you taken on any other borrowing recently?',
    'other-debt-label':
      'Has the business taken on more than £25,000 of borrowing in the last 12 months?',
    'other-debt-amount':
      'How much new debt did your business take in the last 12 months?',
    'govt-debt-label':
      'Specifically, has the business previously taken on debt under any of the following government loan schemes through another provider?',
    'govt-debt-amount':
      'How much outstanding debt does your business have under these government loan schemes?'
  }
};
